/**
 * 默认基于url上的`debug`参数觉得是否启用`DEBUG`级别
 * 在控制台改变__LOGGER_LEVEL__全局日志级别，
 * 从而可以在运行时动态调整日志级别，方便在线调试
 */
function isUrlHasDebug() {
    // 如果 location 不存在, 则认为不包括 `debug` 参数
    if (typeof location === 'undefined') {
        return false;
    }
    const str = location.search.replace(/\?/, '');
    const groups = str.split('&');
    return !!groups.find(g => {
        const [k, v] = g.split('=');
        return k === 'debug' && (v === '1' || v === 'true');
    });
}
/** 默认日志级别
 * @default INFO
 */
const DEFAULT_LEVEL = 'INFO';
const loggerLevelAsNumber = {
    TRACE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
};
const getStandardTimeStr = function () {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60 * 1000;
    const timeStr = new Date(now.getTime() + Math.abs(offset)).toISOString();
    return timeStr.slice(0, -5).replace('T', ' ');
};
const consoleMethods = {
    TRACE: console.trace,
    DEBUG: console.debug,
    INFO: console.info,
    WARN: console.warn,
    ERROR: console.error,
};
let Logger = /** @class */ (() => {
    class Logger {
        constructor(name, options) {
            this.options = { formatTimeStr: true };
            this.module = name;
            options && (this.options = { ...this.options, ...options });
        }
        static get(name, options) {
            return new Logger(name, options);
        }
        static setLevel(level) {
            Logger.level = level;
        }
        /**
         * 获取默认日志级别
         */
        getLoggerLevel() {
            // 如果是 node 开发环境, 则是 `DEBUG` 级别
            if (typeof process !== 'undefined' &&
                process.env.NODE_ENV === 'development') {
                return 'DEBUG';
            }
            // 如果 location 存在 debug 参数, 则是 `DEBUG` 级别
            if (isUrlHasDebug()) {
                return 'DEBUG';
            }
            // 如果是类浏览器环境, 并且存在 __LOGGER_LEVEL__ 的话, 则是 __LOGGER_LEVEL__ 级别
            if (typeof window !== 'undefined' && window.__LOGGER_LEVEL__) {
                return window.__LOGGER_LEVEL__;
            }
            // 除此之外, 使用 `Logger.level` 日志级别
            return Logger.level;
        }
        isEnabledLevel(level) {
            const globalLevel = this.getLoggerLevel();
            const levelNumber = loggerLevelAsNumber[level];
            const globalLevelNumber = loggerLevelAsNumber[globalLevel];
            return levelNumber >= globalLevelNumber;
        }
        format(level, message) {
            const { formatTimeStr } = this.options;
            const logTime = formatTimeStr ? getStandardTimeStr() : new Date();
            return `[${logTime}] [${level}] [${this.module}] - ${message}`;
        }
        log(level, message, ...rest) {
            const fn = consoleMethods[level];
            if (!this.isEnabledLevel(level) || !fn)
                return;
            return fn.call(console, this.format(level, message), ...rest);
        }
        trace(message, ...rest) {
            return this.log('TRACE', message, ...rest);
        }
        debug(message, ...rest) {
            return this.log('DEBUG', message, ...rest);
        }
        info(message, ...rest) {
            return this.log('INFO', message, ...rest);
        }
        warn(message, ...rest) {
            return this.log('WARN', message, ...rest);
        }
        error(message, ...rest) {
            return this.log('ERROR', message, ...rest);
        }
    }
    Logger.level = DEFAULT_LEVEL;
    return Logger;
})();
export default Logger;
//# sourceMappingURL=index.js.map